import { motion } from "motion/react";
import { ReactNode } from "react";
import { cn } from "@/core/helpers/cn";

type Props = {
  children: ReactNode;
  className?: string;
};

export default function InventoryWrapper({ children, className }: Props) {
  return (
    <motion.div
      initial={{
        translateY: "+100%",
        opacity: 0,
      }}
      animate={{
        translateY: "0",
        opacity: 1,
      }}
      transition={{
        bounce: false,
        duration: 0.1,
      }}
      exit={{
        translateY: "-100%",
        opacity: 0,
      }}
      className={cn(
        "flex flex-col bg-dark-900 max-h-full rounded-[0.875rem] overflow-clip shrink-0",
        className,
      )}
    >
      {children}
    </motion.div>
  );
}
